import { useContext, useMemo } from "react";
import { GeaoContext } from "../GeaoContextProvider";

/**
 * Custom hook to detect if the current agency interview is a cobranded sub-agency.
 * 
 * A cobranded agency is identified by having a value in the CobrandedNationalAccount field.
 * When cobranded, the backend will have already populated the interview with:
 * - AffiliatedWithTop100 = "false"
 * - AgencyCommissionPayments = "false"
 * - ParentAgencyName, ParentAgencyEmailAddress, ParentAgencyFEIN (from parent agency lookup)
 * 
 * @returns {Object} Object containing:
 *   - isCobrandedAgency: boolean indicating if this is a cobranded agency interview
 *   - cobrandedNationalAccount: the cobranded national account value (or null)
 */
export default function useCobrandedAgency() {
    const { agencyInterview } = useContext(GeaoContext);

    return useMemo(() => {
        const cobrandedNationalAccount = agencyInterview?.questionAnswers?.CobrandedNationalAccount?.answer ?? null;

        return {
            isCobrandedAgency: !!cobrandedNationalAccount,
            cobrandedNationalAccount
        };
    }, [agencyInterview]);
}
